import axiosInstance from "auth/FetchInterceptor";
import {
  SETTING_AUTH_API,
  GET_ALL_SETTING_AUTH_API,
} from "constants/ApiConstant";
const SettingAuthsService = {};

SettingAuthsService.getAuthListApi = function () {
  return axiosInstance.get(GET_ALL_SETTING_AUTH_API, null);
};

SettingAuthsService.updateAuthSettingApi = function (data) {
  return axiosInstance.put(SETTING_AUTH_API, data);
};

export default SettingAuthsService;
